module.exports = __webpack_public_path__ + "img/screenshot_certificate_link_mobile.645e1eea.jpg";